import { render, staticRenderFns } from "./packageSelectDotRead.vue?vue&type=template&id=a463c73e&scoped=true"
import script from "./packageSelectDotRead.vue?vue&type=script&lang=js"
export * from "./packageSelectDotRead.vue?vue&type=script&lang=js"
import style0 from "./packageSelectDotRead.vue?vue&type=style&index=0&id=a463c73e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a463c73e",
  null
  
)

export default component.exports